import { render, staticRenderFns } from "./trust-pilot.vue?vue&type=template&id=5e8f8b88"
import script from "./trust-pilot.vue?vue&type=script&lang=js"
export * from "./trust-pilot.vue?vue&type=script&lang=js"
import style0 from "./trust-pilot.vue?vue&type=style&index=0&id=5e8f8b88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports